{
	"editMenu": "Edit menu",
	"addMenu": "Add a new menu",
	"menuForm": {
		"delivery": "Delivery",
		"table": "Order on the table"
	},
	"menuInformation": "Menu information",
	"name": "Menu name",
	"type": "Type of menu",
	"workingPeriods": "Menu opening hours",
	"save": "Save changes",
	"create": "Create menu",
	"day": "Day",
	"startTime": "Start time",
	"endTime": "End time",
	"start": "Start",
	"end": "End",
	"validateField": "Required field"
}
